import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import {
  ApiResponseMessage,
  ICreateSurveyFormPayload,
} from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

// Save or update survey form thunk
export const saveSurveyForm = createServiceAsyncThunk<
  ApiResponseMessage,
  ICreateSurveyFormPayload
>(
  ACTION_NAMES.SAVE_UPDATE_SURVEY_FORM,
  (payload) => surveyFormsService.submitSurveyForm(payload),
  ERROR_MESSAGES.SAVE_UPDATE_SURVEY_FORM_FAILURE
);

// Slice
const saveUpdateSurveyFormSlice = createGenericSlice<
  ApiResponseMessage,
  ICreateSurveyFormPayload
>(SLICE_NAMES.SAVE_UPDATE_SURVEY_FORM_SLICE, saveSurveyForm);

export const {
  clearError: clearSaveSurveyFormError,
  clearSuccessMessage: clearSaveSurveyFormSuccess,
} = saveUpdateSurveyFormSlice.actions;

export default saveUpdateSurveyFormSlice.reducer;
